<template>
    <g>
        <path 
            v-bind="{
                class : 'tool_svgElem',
                id : tool.id + '-body',
                d : d_path()
            }"
        />
    </g>
</template>

// =========================================================================================
// =========================================================================================

<script>
import { tools } from '../../mixins/tools';
import { paths } from '../../mixins/paths';

// =========================================================================================

export default {
    name : 'pathCMP',
    mixins: [tools, paths],

    // -----------------------------------------------------------------

    data () {
        return {
        }
    },

    // -----------------------------------------------------------------

    computed: {  
    },

    // -----------------------------------------------------------------

    methods: {
    },
}
</script>

// =========================================================================================
// =========================================================================================

<style scoped>
</style>